import React, { ReactElement } from 'react';
import { Provider } from 'react-redux';
import createSagaMiddleware, { SagaMiddleware } from 'redux-saga';
import { all } from 'redux-saga/effects';
import { configureStore, Tuple } from '@reduxjs/toolkit';
import MainService from '../../services/main-service';
import { NODE_ENV_PRODUCTION } from '../../constants/system/node-envs';

const StoreProvider: ReactComponent = (props: ReactComponentProps): ReactElement => {
  const {
    reducerMap,
    sagaMap,
    children,
  } = props;

  function* initSagas(): Generator<ReduxSagas> {
    yield all(sagaMap);
  }

  const initStore: Function = (): StoreInstance => {
    const sagaMiddleware: SagaMiddleware = createSagaMiddleware();

    const store: StoreInstance = configureStore({
      reducer: reducerMap,
      devTools: MainService.NODE_ENV !== NODE_ENV_PRODUCTION,
      middleware: () => new Tuple(sagaMiddleware),
    });

    sagaMiddleware.run(initSagas);

    return store;
  };

  const Store: StoreInstance = initStore();

  return (
    <Provider store={Store}>
      {children}
    </Provider>
  );
};

export default StoreProvider;
